export default __webpack_public_path__ + "resources/icons/d430-1601.webp";